module.exports = __webpack_public_path__ + "img/mariokart_01.4c52c4d2.jpg";